//Library Imports

// application components goes here
import { LOGIN, RESET_PASSWORD, SIGNUP } from '../../constants/actionTypes';
import store from '../../store/index';
import {
  login,
  signup,
  resetPassword,
  setNewPassword,
  setHideFirstTimeMessageAmazingServices,
  getUserDataService,
  setDoNotShowPopupAgainService,
  logoutService,
  getUserPlanTypeService,
  getAccountDetailsService,
} from '../Services/LoginService';
import { XIQ_ONLINE_URL, setCookies } from '../../constants/index';
import { USER_ACCOUNT_DETAILS, USER_DETAILS } from 'constants/types';
import { getRedirectionPath, resetRedirectionPath } from 'utils';
import secureLocalStorage from 'react-secure-storage';

//Calls axios service to log in user.
export function getLoginService(formData: FormData) {
  return login(formData)
    .then((response) => {
      //To update store state
      console.log('Login : ', response);
      store.dispatch({
        type: LOGIN.LOAD_SUCCESS,
        payload: response.data,
      });
      if (response.status === 200) {
        secureLocalStorage.setItem('plantype', response.data.plantype);

        store.dispatch({ type: USER_DETAILS.SET_PLAN_TYPE, planType: response.data.plantype });
        // localStorage.setItem("Username", response.data.fullname);
        if (response.data.status === 'False') {
          return {
            status: false,
            message: response.data.message,
            type: 'error',
            label: 'Error!',
          };
        } else {
          setCookies(response.data);
          return response.data;
        }
      } else {
        return {
          status: false,
          message: response.data.message,
          type: 'error',
          label: 'Error!',
        };
      }
    })
    .catch((err) => {
      console.log(err);
    });
}

export function getSignup(data: any) {
  store.dispatch({
    type: SIGNUP.LOAD,
  });
  return signup(data)
    .then((response) => {
      store.dispatch({
        type: SIGNUP.LOAD_SUCCESS,
        payload: response.data,
      });
    })
    .catch((err) => {
      store.dispatch({
        type: SIGNUP.LOAD_FAIL,
      });
      console.log(err);
    });
}

//Password Reset service called to send an email to user.
export function getResetPasswordService(formData: FormData) {
  return resetPassword(formData)
    .then((response) => {
      store.dispatch({
        type: RESET_PASSWORD.LOAD_SUCCESS,
        payload: response.data,
      });
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
}

//set new password
export function setNewPasswordService(formData: FormData) {
  return setNewPassword(formData)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log('setNewPassword error : ', err);
      return err;
    });
}

export function setHideFirstTimeMessageAmazing() {
  store.dispatch({
    type: USER_DETAILS.CLICKED_AMAZING,
  });
  //* implement API for setting the flag
  setHideFirstTimeMessageAmazingServices()
    .then((response) => {
      console.log('setHideFirstTimeMessageAmazingServices : ', response.data);
    })
    .catch((error) => {
      console.log('Error setHideFirstTimeMessageAmazingServices : ', error);
    });
}

export function getUserData() {
  // store.dispatch({
  //   type: " ",
  // });
  store.dispatch({
    type: USER_DETAILS.LOAD,
  });
  getUserDataService()
    .then((res) => {
      if (res.data.success) {
        // For initial page rendering in Setting -> Forms
        localStorage.setItem('totalForms', res.data.user_data.total_forms);
        // SUCCESS
        store.dispatch({
          type: USER_DETAILS.SUCCESS,
          payload: {
            ...res.data.user_data,
          },
        });
      }
    })
    .catch((err) => {
      console.log('Error getUserData Service : ', err);
    });
}

export function showTooltipPopupFirstTime() {
  store.dispatch({
    type: USER_DETAILS.SHOW_TOOL_TIP_FIRST_TIME,
  });
}

export function hideTooltipPopupFirstTime() {
  store.dispatch({
    type: USER_DETAILS.HIDE_TOOL_TIP_FIRST_TIME,
  });
}

export function setDoNotShowTooltipPopupAgain() {
  store.dispatch({
    type: USER_DETAILS.SET_DO_NOT_SHOW_ASSET_BROWSER_POPUP,
  });
  setDoNotShowPopupAgainService()
    .then((res) => {
      console.log('setDoNotShowPopupAgainService Response: ', res);
    })
    .catch((err) => {
      console.log('setDoNotShowPopupAgainService Error: ', err);
    });
}

export function getUserPlanType(history?: any, firstLogin?: string, hasCampaigns?: string) {
  getUserPlanTypeService()
    .then((response) => {
      console.log('fetching user plan type Response: ', response);
      if (response.status === 200 && response.data.user !== undefined) {
        secureLocalStorage.setItem('plantype', response.data.user.planType.toUpperCase());
        store.dispatch({ type: USER_DETAILS.SET_PLAN_TYPE, planType: response.data.user.planType.toUpperCase() });

        if (history) {
          // check if redirection path is in local storage
          const redirectionPath = getRedirectionPath();
          console.log('redirectionPath in WB = ', redirectionPath);
          if (redirectionPath && firstLogin != '1') {
            resetRedirectionPath();
            history.push(redirectionPath);
          } else if (firstLogin == '1') {
            history.push('/welcome');
          } else {
            console.log('hasCampaigns = ', hasCampaigns);
            console.log('typeof hasCampaigns = ', typeof hasCampaigns);

            if (hasCampaigns?.trim() === 'true') {
              history.push('/campaigns');
            } else {
              history.push('/content/explorer');
            }
          }
        }
      }
    })
    .catch((error) => {
      if (error.response?.status === 403) {
        sessionStorage.clear();
        window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.origin}`;
      }
      console.log('Error in fetching user plan type: ', error);
    });
}

export function logOut() {
  let data = {
    deviceToken: 'undefined',
    username: localStorage.getItem('username'),
    appName: 'workbench',
  };
  return logoutService(data);
}

export function getAccountDetails() {
  store.dispatch({
    type: USER_ACCOUNT_DETAILS.LOAD,
  });
  getAccountDetailsService()
    .then(({ data }) => {
      const { response } = data;
      const { profilePic, personCard, email, fullName } = response;
      if (profilePic) {
        store.dispatch({
          type: USER_ACCOUNT_DETAILS.SUCCESS,
          payload: { profilePic, personCard, email, fullName },
        });
      }
    })
    .catch((error) => {
      console.log('Error in fetching user account details: ', error);
    });
}
